interface ProgressBarProps {
  label?: string;
  value?: number;
  color?: string;
  showLabel?: boolean;
}

export function ProgressBarBlock({ props }: { props: ProgressBarProps }) {
  const value = Math.min(100, Math.max(0, props.value ?? 0));
  const color = props.color || '#6366f1';

  return (
    <div className="py-2">
      {(props.showLabel !== false) && (
        <div className="flex justify-between mb-1.5">
          <span className="text-sm font-medium text-zinc-700">{props.label ?? 'Progress'}</span>
          <span className="text-sm text-zinc-500">{value}%</span>
        </div>
      )}
      <div className="w-full h-3 bg-zinc-200 rounded-full overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{ width: `${value}%`, backgroundColor: color }}
        />
      </div>
    </div>
  );
}
